import { useNavigate } from 'react-router-dom';

// styles
import {
    TitleContainer,
} from './Title.styles';

// components
import PrimaryBtn from '../../../btns/primary-btn/PrimaryBtn';

export default function Title({ text, btnPath = null, style = {}, alignItems = 'start' }) {
    const navigate = useNavigate();

    const handleNavigate = () => {
        if (btnPath.path === -1) {
          navigate(-1); // go back one page
        } else {
          navigate(btnPath.path); // go to specific path
        }
      };

    return (
        <TitleContainer style={style} $alignItems={alignItems}>
            <h1>{text}</h1>
            {btnPath !== null &&
                <div style={{ width: "160px" }}>
                    <PrimaryBtn title={btnPath.title} onClick={handleNavigate} />
                </div>
            }
        </TitleContainer>
    )
}
